import { GET } from "../../apiController";

const ORG_ADMIN_DASHBOARD = '/admin/orgdashboard';

// Get admin dashboard data
export const getDashboardData = () => {
  return GET(`${ORG_ADMIN_DASHBOARD}/dashboard_data`);
};